// import { Component, HostListener } from '@angular/core';
// import { Router } from '@angular/router';
// import { CommonModule } from '@angular/common';
 
// @Component({
//   selector: 'app-footer',
//   templateUrl: './footer.component.html',
//   styleUrls: ['./footer.component.scss'],
//   imports: [CommonModule],
//   standalone: true
// })
// export class FooterComponent {
//   currentyear: number = new Date().getFullYear();
//   isShow: boolean = false;
//   topPosToStartShowing: number = 100;
 
//   constructor(private router: Router) {}
 
//   @HostListener('window:scroll')
//   checkScroll(): void {
//     const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
//     this.isShow = scrollPosition >= this.topPosToStartShowing;
//   }
 
//   gotoTop(): void {
//     window.scroll({ top: 0, left: 0, behavior: 'smooth' });
//   }
 
//   nav(url: string): void {
//     this.router.navigateByUrl(url);
//   }
// }


import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router ,ActivatedRoute} from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContactUsComponent } from '../contact-us/contact-us.component';

interface ContactPhone {
  icon: string;
  label: string;
  number: string;
  telNumber: string;
  badge: string;
}

interface ContactEmail {
  email: string;
  badge: string;
}

interface SocialLink {
  name: string;
  icon: string;
  url: string;
}

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  constructor(private router: Router, private modalService: NgbModal) {}
  currentyear: number = new Date().getFullYear();
  contactPhones: ContactPhone[] = [
    {
      icon: '🏢',
      label: 'INDIA Office',
      number: '(+91) 87620 33990',
      telNumber: '+918762033990',
      badge: 'CALL'
    },
    {
      icon: '🏢',
      label: 'USA Office',
      number: '(+1) 512 640 3251',
      telNumber: '+15126403251',
      badge: 'CALL'
    },
    {
      icon: '🏢',
      label: 'Sales',
      number: '(+91) 89040 87107',
      telNumber: '+918904087107',
      badge: 'CALL EX.'
    },
    {
      icon: '🏢',
      label: 'Recruitment',
      number: '(+91) 87620 11217',
      telNumber: '+918762011217',
      badge: ''
    }
  ];

openContactModal(): void {
  this.modalService.open(ContactUsComponent, {
    centered: true,
    backdrop: 'static',
    windowClass: 'contact-modal'
  });
}

  contactEmails: ContactEmail[] = [
    { email: 'Connect@kalpitatechnologies.com', badge: '' },
    { email: 'operations@kalpitatechnologies.com', badge: '' },
    { email: 'sales@kalpitatechnologies.com', badge: 'CALL EX.' },
    { email: 'recruitment@kalpitatechnologies.com', badge: '' },
    { email: 'Recruit_US@kalpitatechnologies.com', badge: '' }
  ];

usefulLinks = [
  { label: 'About Us', route: 'aboutcompany/about-kalpita-technologies' },
  { label: 'Case Studies', route: 'kalpita-case-studies/case-study' },
  { label: 'Careers', route: 'careers/career-at-kalpita' },
  { label: 'Blog', route: 'tech-blogs/blog' },
  { label: 'Contact', route: 'CONTACT_MODAL' },
  { label: 'Newsletter', route: 'news-letters/newsletter' },
  { label: 'Annual Report', route: 'aboutcompany/kalpita-annual-reports' },
  { label: 'KT Brochure', route: 'BROCHURE' }
];

  socialLinks: SocialLink[] = [
    { name: 'YouTube', icon: 'youtube', url: '#' },
    { name: 'LinkedIn', icon: 'linkedin', url: '#' },
    { name: 'Instagram', icon: 'instagram', url: '#' },
    { name: 'Facebook', icon: 'facebook', url: '#' },
    { name: 'Twitter', icon: 'twitter', url: '#' },
    { name: 'Threads', icon: 'threads', url: '#' }
  ];

onLinkClick(route: string): void {
  this.router.navigateByUrl('/' + route);
  window.scrollTo(0, 0);
}

  onSocialClick(event: Event, social: string): void {
    event.preventDefault();
    console.log('Opening social media:', social);
    // Add your social media navigation logic here
  }
   nav(url: any) {
    this.router.navigateByUrl(url)
  }
}

